import React from "react";
import { Grid } from "@mui/material";
import CalendarDayCell from "./CalendarDayCell";

const CalendarGridRows = ({
  calendarMonth,
  selectedDate,
  onDateSelect,
  availableSlotsMap,
  isDateDisabled,
  minDate,
  maxDate,
  today,
  colorRules,
}) => {
  const startOfMonth = calendarMonth.startOf("month");
  const endOfMonth = calendarMonth.endOf("month");
  const totalDays = endOfMonth.date();
  const firstWeekday = startOfMonth.day();

  const emptyCells = Array.from({ length: firstWeekday }, (_, i) => (
    <Grid item xs={1.71} sm={1.71} key={`empty-${i}`} />
  ));

  const dayCells = Array.from({ length: totalDays }, (_, i) => (
    <CalendarDayCell
      key={i}
      date={startOfMonth.add(i, "day")}
      selectedDate={selectedDate}
      onSelect={onDateSelect}
      availableSlotsMap={availableSlotsMap}
      isDateDisabled={isDateDisabled}
      minDate={minDate}
      maxDate={maxDate}
      today={today}
      colorRules={colorRules}
    />
  ));

  const allCells = [...emptyCells, ...dayCells];
  const rows = [];
  for (let i = 0; i < allCells.length; i += 7) {
    rows.push(
      <Grid
        container
        spacing={1}
        key={`week-${i}`}
        sx={{
          marginTop: "10px",
          marginLeft: "-8px",
          width: "calc(100% + 8px)",
        }}>
        {allCells.slice(i, i + 7)}
      </Grid>
    );
  }

  return rows;
};

export default CalendarGridRows;
